import React from 'react';
import PropTypes from 'prop-types';
import Icon, { IconList } from 'components/Icon';
import "./FloatMenu.css";
import hamburger from 'assets/svgicon/icon-hamburger.png';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';
import { useGeneralSetting } from 'context/GeneralSettingContext';
import { useUserSensorGroups } from 'hooks/useUserSensorGroups';
import { TEXT_MANAGEMENT_SETTING, TEXT_MASTER_MANAGEMENT, TEXT_SENSOR_FLOOD, TEXT_SENSOR_FLOOD_GATE, TEXT_SENSOR_CAMERA, TEXT_SENSOR_LIST, TEXT_SENSOR_MANAGEMENT, TEXT_SENSOR_MAP, TEXT_USER_MANAGEMENT, TEXT_SENSOR_GENERAL } from 'constants/message';
import { AccountType } from 'models';
import { PAGE_FLOOD_GATE_SENSOR_LIST, PAGE_FLOOD_SENSOR_LIST, PAGE_CAMERA_SENSOR_LIST, PAGE_SENSOR_MANAGEMENT, PAGE_MAP, PAGE_MASTER_MANAGEMENT, PAGE_PROFILE, PAGE_USER_MANAGEMENT, PAGE_GENERAL_SENSOR_LIST } from 'utils/constanst';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { logoutCognitoUser } from 'apis/UserApi';

const MENU_ITEMS = [
  {
    id: 'separator-1',
    separator: true,
    owners: [AccountType.USER, AccountType.MANAGER, AccountType.ADMIN],
  },
  {
    id: 'header-1',
    header: TEXT_SENSOR_MANAGEMENT,
    owners: [AccountType.USER, AccountType.MANAGER, AccountType.ADMIN],
  },
  {
    id: PAGE_MAP,
    icon: IconList.iconMenuMap,
    text: TEXT_SENSOR_MAP,
    owners: [AccountType.USER, AccountType.MANAGER, AccountType.ADMIN]
  },
  {
    id: PAGE_FLOOD_SENSOR_LIST + '_' + PAGE_FLOOD_GATE_SENSOR_LIST, // control submenu
    icon: IconList.iconMenuSensorDetail,
    text: TEXT_SENSOR_LIST,
    owners: [AccountType.USER, AccountType.MANAGER, AccountType.ADMIN],
    children: [
      {
        id: PAGE_CAMERA_SENSOR_LIST,
        icon: IconList.iconMenuSensorDetail,
        text: TEXT_SENSOR_CAMERA,
        owners: [AccountType.USER, AccountType.MANAGER, AccountType.ADMIN],
      },
      {
        id: PAGE_FLOOD_SENSOR_LIST,
        icon: IconList.iconMenuSensorDetail,
        text: TEXT_SENSOR_FLOOD,
        owners: [AccountType.USER, AccountType.MANAGER, AccountType.ADMIN]
      },
      {
        id: PAGE_FLOOD_GATE_SENSOR_LIST,
        icon: IconList.iconMenuSensorDetail,
        text: TEXT_SENSOR_FLOOD_GATE,
        owners: [AccountType.USER, AccountType.MANAGER, AccountType.ADMIN],
      },
      {
        id: PAGE_GENERAL_SENSOR_LIST,
        icon: IconList.iconMenuSensorDetail,
        text: TEXT_SENSOR_GENERAL,
        owners: [AccountType.USER, AccountType.MANAGER, AccountType.ADMIN],
      },
    ]
  },
  {
    id: 'separator-2',
    separator: true,
    owners: [AccountType.MANAGER, AccountType.ADMIN],
  },
  {
    id: 'header-2',
    header: TEXT_MANAGEMENT_SETTING,
    owners: [AccountType.MANAGER, AccountType.ADMIN],
  },
  {
    id: PAGE_SENSOR_MANAGEMENT,
    icon: IconList.iconMenuSensorManage,
    text: TEXT_SENSOR_MANAGEMENT,
    owners: [AccountType.MANAGER, AccountType.ADMIN],

  },
  {
    id: PAGE_USER_MANAGEMENT,
    icon: IconList.iconMenuUser,
    text: TEXT_USER_MANAGEMENT,
    owners: [AccountType.MANAGER, AccountType.ADMIN],
  },
  {
    id: PAGE_MASTER_MANAGEMENT,
    icon: IconList.iconMenuMaster,
    text: TEXT_MASTER_MANAGEMENT,
    owners: [AccountType.ADMIN],
  }
]

const propTypes = {
  selectedItem: PropTypes.number,
  onClickItem: PropTypes.func
};
const defaultProps = {};
const FloatMenu = (props) => {
  /*** States and Variables ***/
  const [isOpen, setIsOpen] = React.useState(false);
  const navigate = useNavigate();
  const { currentUser, setCurrentUser } = useAuth();
  const { generalSetting } = useGeneralSetting();
  const groupNames = useUserSensorGroups();
  const menuRef = React.useRef(null);
  const [openStates, setOpenStates] = React.useState([]);
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

  /*** Processing ***/
  React.useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const logOut = async () => {
    try {
      await logoutCognitoUser();
      setCurrentUser(null);
      navigate("/login");
    } catch (e) {
      console.error(e)
    }
  }
  /*** Sub Components ***/
  const renderMenuItem = (item, level = 1) => {
    if (item.owners.includes(currentUser?.accountType)) {
      if (item.separator) {
        return <div key={item.id} className='float_menu_separator' />
      }
      if (item.header) {
        return <div key={item.id} className='float_menu_group_header'>
          {item.header}
        </div>
      }
      let childrenToRender = item.children;
      if (item.text === TEXT_SENSOR_LIST && Array.isArray(item.children)) {
        childrenToRender = item.children.filter(child => groupNames.includes(child.text));
      }
      if (item.text === TEXT_SENSOR_LIST && (!childrenToRender || childrenToRender.length === 0)) {
        return null;
      }
      return <React.Fragment key={item.id}>
        <div
          onClick={() => { onClickItem(item) }}
          className={props.selectedItem === item.id ? 'float_menu_menu_item_selected' : 'float_menu_menu_item'}
          style={{
            paddingLeft: `${14 * level}px`
          }}>
          <div className='float_menu_menu_item_left_side'>
            <Icon icon={item.icon} />
            <label className='float_menu_menu_item_text'>{item.text}</label>
          </div>
          {childrenToRender && childrenToRender.length > 0 &&
            <FontAwesomeIcon
              icon={faChevronRight}
              className={openStates.includes(item.id) ? 'float_menu_up_arrow' : 'float_menu_down_arrow'} />}
        </div>
        {childrenToRender && childrenToRender.length > 0 &&
          <div
            className='float_menu_submenu_container'
            style={{
              maxHeight: `${openStates.includes(item.id) ? 72 * childrenToRender.length : 0}px`
            }}>
            {childrenToRender.map(child => renderMenuItem(child, level + 1))}
          </div>}
      </React.Fragment>;
    }
    return null;
  }
  /*** Event Handlers ***/
  const onClickItem = (item) => {
    if (item.children) {
      const childrenToConsider = item.text === TEXT_SENSOR_LIST 
        ? item.children.filter(child => groupNames.includes(child.text)) 
        : item.children;
      
      if (childrenToConsider && childrenToConsider.length > 0) {
        if (openStates.includes(item.id)) {
          setOpenStates(openStates.filter(s => s !== item.id));
        }
        else {
          openStates.push(item.id);
          setOpenStates(Object.assign([], openStates));
        }
      }
    }
    else if (item.id) {
      props.onClickItem(item.id);
      setIsOpen(false);
    }
  }
  const onBlur = (e) => {
    if (!menuRef.current.contains(e.relatedTarget)) {
      setIsOpen(false);
    }
  }
  /*** Main Render ***/
  // Don't render anything until both currentUser and generalSetting are loaded
  if (!currentUser || !generalSetting) {
    return null;
  }
  
  // Show logout button for USER account type when menuType is tab
  if ((currentUser?.accountType === AccountType.USER || currentUser?.accountType === AccountType.MANAGER) && generalSetting?.menuType === 'tab') {
    return <div className='float_menu_anchor'>
      <button
        className='float_menu_logout_button'
        style={{
          top: '0.3rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: windowWidth < 1025 ? '29px' : '32px',
          width: 'auto',
          margin: '8px',
          padding: '0 3px',
        }}
        onClick={logOut}>
        <Icon icon={IconList.iconMenuLogout} />
      </button>
    </div>;
  }

  // Show hamburger menu for MANAGER and ADMIN
  return <div
    className='float_menu_anchor'
    tabIndex={100}
    ref={menuRef}
    onBlur={onBlur}>
    <button
      className='float_menu_menu_button'
      onClick={() => { setIsOpen(prev => !prev) }}>
      <img
        src={hamburger}
        alt='menu'
        className='float_menu_menu_button_icon' />
      <p className='float_menu_menu_button_text'>メニュー</p>
    </button>
    <div
      className='float_menu_menu_container'
      style={{
        display: isOpen ? 'block' : 'none'
      }}>
      <div
        className='float_menu_menu_item'
        onClick={() => { setIsOpen(false); props.onClickItem(PAGE_PROFILE) }}>
        <div className='float_menu_menu_item_left_side'>
          <Icon icon={IconList.iconUser} />
          <label className='float_menu_menu_item_text'>{currentUser?.name || ''}</label>
        </div>
      </div>
      {
        MENU_ITEMS.map((item) => renderMenuItem(item))
      }
      <div className='float_menu_separator' />
      <div
        className='float_menu_menu_item'
        onClick={logOut}>
        <div className='float_menu_menu_item_left_side'>
          <Icon icon={IconList.iconMenuLogout} />
          <label className='float_menu_menu_item_text'>ログアウト</label>
        </div>
      </div>
    </div>
  </div>;
}
FloatMenu.propTypes = propTypes;
FloatMenu.defaultProps = defaultProps;
export default FloatMenu;